import { useEffect, useState } from 'react'
import { ServiceConfig } from '@user/store/services/config'
import { get } from '@user/store/services/crud'
import { BillTo } from '../typings'

export const useGetBillToOnMount = (locationId: string | null) => {
  const [billTo, setBillTo] = useState<BillTo>()

  const [loadingStatus, setLoadingStatus] = useState<
    'pending' | 'failure' | 'success'
  >()

  useEffect(() => {
    const baseUrl = `${ServiceConfig.baseAPIUrl}/${ServiceConfig.billTo.billTo}`
    const execute = async () => {
      if (locationId) {
        try {
          setLoadingStatus('pending')
          const response = await get(`${baseUrl}/${locationId}`)
          if (response.ok) {
            const location: BillTo = await response.json()
            setBillTo(location)
          }
        } catch (error) {
          console.error(error)
          setLoadingStatus('failure')
        } finally {
          setLoadingStatus('success')
        }
      }
    }
    execute()
  }, [locationId])

  return { billTo, loadingStatus }
}
